(function () {
  var allBars = document.querySelectorAll("[data-section-id][data-config]");
  if (!allBars.length) return;

  var instances = [];
  var currentCart = null;
  var activeGiftKey = null;
  var freeGiftLineProperty = "_free_gift";

  allBars.forEach(function (el) {
    var config = {};
    try {
      config = JSON.parse(el.getAttribute("data-config") || "{}");
    } catch (e) {}

    instances.push({
      el: el,
      isCart: el.getAttribute("data-context") === "cart",
      thresholds: config.thresholds || [],
      currency: config.currency || "€",
      progressTpl: config.progress_message || "You're [amount] away from [reward]",
      unlockedTpl: config.unlocked_message || "You unlocked [reward]!",
      finalTpl: config.final_message || "",
      enableGift: config.enable_gift || false
    });
  });

  /* ===== CART SWIPER ===== */

  var cartSwiperInstance = null;
  var cartSwiperEl = null;

  function initCartSwiper(el) {
    var container = el.querySelector(".et-discount-bar__cart-swiper");
    if (!container) return;
    if (cartSwiperEl === container && cartSwiperInstance && !cartSwiperInstance.destroyed) return;
    if (typeof Swiper === "undefined") {
      setTimeout(function () { initCartSwiper(el); }, 100);
      return;
    }
    if (cartSwiperInstance) {
      try { cartSwiperInstance.destroy(true, true); } catch (e) {}
      cartSwiperInstance = null;
    }
    cartSwiperEl = container;
    cartSwiperInstance = new Swiper(container, {
      slidesPerView: 1.15,
      centeredSlides: true,
      centeredSlidesBounds: true,
      spaceBetween: 8,
      pagination: {
        el: container.querySelector(".et-discount-bar__swiper-pagination"),
        clickable: true,
        bulletClass: "et-discount-bar__swiper-bullet",
        bulletActiveClass: "et-discount-bar__swiper-bullet--active",
      },
      scrollbar: {
        el: container.querySelector(".et-discount-bar__swiper-scrollbar"),
        draggable: true,
      },
      navigation: {
        nextEl: container.querySelector(".et-discount-bar__cart-swiper-next"),
        prevEl: container.querySelector(".et-discount-bar__cart-swiper-prev"),
      },
    });
  }

  /* ===== SHARED CART FETCH ===== */

  function refreshAll() {
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        currentCart = cart;
        findActiveGiftInCart(cart);
        document.querySelectorAll("[data-section-id][data-config]").forEach(function (el) {
          var config = {};
          try { config = JSON.parse(el.getAttribute("data-config") || "{}"); } catch (e) {}
          var inst = {
            el: el,
            isCart: el.getAttribute("data-context") === "cart",
            thresholds: config.thresholds || [],
            currency: config.currency || "€",
            progressTpl: config.progress_message || "You're [amount] away from [reward]",
            unlockedTpl: config.unlocked_message || "You unlocked [reward]!",
            finalTpl: config.final_message || "",
            enableGift: config.enable_gift || false
          };
          updateUI(inst, cart);
          if (inst.isCart) initCartSwiper(el);
        });
      })
      .catch(function () {});
  }

  function interceptCartRequests() {
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var urlStr = typeof url === "string" ? url : url && url.url ? url.url : "";
      var isCartMutation = /\/cart\/(add|change|update|clear)/.test(urlStr);
      var result = origFetch.apply(this, arguments);
      if (isCartMutation) {
        result
          .then(function () {
            setTimeout(refreshAll, 300);
            setTimeout(refreshAll, 1500);
          })
          .catch(function () {});
      }
      return result;
    };
  }

  /* ===== UPDATE UI (fresh DOM queries each time) ===== */

  function updateUI(inst, cart) {
    var section = inst.el;
    var thresholds = inst.thresholds;
    if (thresholds.length === 0) return;

    var cartTotal = calculateCartTotal(cart);

    var fill = section.querySelector(".et-discount-bar__fill");
    var fillPercent = calculateFillPercent(section, thresholds, cartTotal);
    if (fill) fill.style.width = fillPercent + "%";

    var unlockedIndex = -1;
    for (var i = thresholds.length - 1; i >= 0; i--) {
      if (cartTotal >= thresholds[i].amount) {
        unlockedIndex = i;
        break;
      }
    }

    var milestones = section.querySelectorAll(".et-discount-bar__milestone");
    milestones.forEach(function (m, idx) {
      if (idx <= unlockedIndex) {
        m.classList.add("is-unlocked");
      } else {
        m.classList.remove("is-unlocked");
      }
    });

    updateMessage(inst, cartTotal, unlockedIndex);
    updateGiftVisibility(inst, unlockedIndex);
    updateProgressVisibility(inst, unlockedIndex);

    if (inst.enableGift && unlockedIndex < thresholds.length - 1 && activeGiftKey) {
      removeGiftFromCart(activeGiftKey);
    }
  }

  function calculateCartTotal(cart) {
    if (!cart || !cart.items) return 0;
    var total = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.properties && item.properties[freeGiftLineProperty] === "true") continue;
      total += item.final_line_price;
    }
    return total / 100;
  }

  function calculateFillPercent(section, thresholds, cartTotal) {
    var track = section.querySelector(".et-discount-bar__track");
    var milestoneEls = section.querySelectorAll(".et-discount-bar__milestone");
    if (!track || milestoneEls.length === 0) return 0;

    var trackRect = track.getBoundingClientRect();
    var trackWidth = trackRect.width;

    var positions = [];
    if (trackWidth > 0) {
      milestoneEls.forEach(function (m) {
        var mRect = m.getBoundingClientRect();
        var center = (mRect.left + mRect.width / 2) - trackRect.left;
        positions.push((center / trackWidth) * 100);
      });
    } else {
      var count = milestoneEls.length;
      for (var p = 0; p < count; p++) {
        positions.push(((p + 1) / count) * 100);
      }
    }

    if (cartTotal <= 0) return 0;
    if (cartTotal >= thresholds[thresholds.length - 1].amount) return positions[positions.length - 1];

    if (cartTotal < thresholds[0].amount) {
      return (cartTotal / thresholds[0].amount) * positions[0];
    }

    for (var i = 0; i < thresholds.length - 1; i++) {
      if (cartTotal < thresholds[i + 1].amount) {
        var segmentProgress = (cartTotal - thresholds[i].amount) / (thresholds[i + 1].amount - thresholds[i].amount);
        return positions[i] + segmentProgress * (positions[i + 1] - positions[i]);
      }
    }
    return positions[positions.length - 1];
  }

  function updateProgressVisibility(inst, unlockedIndex) {
    var progressSection = inst.el.querySelector(".et-discount-bar__progress-section");
    if (!progressSection) return;
    var allUnlocked = unlockedIndex === inst.thresholds.length - 1;
    if (allUnlocked) {
      progressSection.classList.add("is-hidden");
    } else {
      progressSection.classList.remove("is-hidden");
    }
  }

  function updateMessage(inst, cartTotal, unlockedIndex) {
    var messageEl = inst.el.querySelector(".et-discount-bar__message");
    var badgeEl = inst.el.querySelector(".et-discount-bar__badge");
    if (!messageEl || !badgeEl) return;

    var thresholds = inst.thresholds;
    var allUnlocked = unlockedIndex === thresholds.length - 1;

    if (allUnlocked) {
      var label = thresholds[thresholds.length - 1].label;
      var msg = inst.finalTpl || inst.unlockedTpl;
      messageEl.textContent = msg.replace("[reward]", label);
      badgeEl.textContent = label;
      badgeEl.style.display = "none";
      return;
    }

    if (unlockedIndex >= 0 && unlockedIndex < thresholds.length - 1) {
      var nextThreshold = thresholds[unlockedIndex + 1];
      var diff = (nextThreshold.amount - cartTotal).toFixed(2).replace(".", ",").replace(',00', '');
      messageEl.textContent = inst.progressTpl
        .replace("[amount]", inst.currency + diff)
        .replace("[reward]", nextThreshold.label);
      badgeEl.textContent = nextThreshold.label;
      badgeEl.style.display = "";
    } else {
      var firstThreshold = thresholds[0];
      var diff2Raw = firstThreshold.amount - cartTotal;
      if (diff2Raw < 0) diff2Raw = 0;
      var diff2 = diff2Raw.toFixed(2).replace(".", ",").replace(',00', '');
      messageEl.textContent = inst.progressTpl
        .replace("[amount]", inst.currency + diff2)
        .replace("[reward]", firstThreshold.label);
      badgeEl.textContent = firstThreshold.label;
      badgeEl.style.display = "";
    }
  }

  function updateGiftVisibility(inst, unlockedIndex) {
    var giftSection = inst.el.querySelector(".et-discount-bar__gift-section");
    if (!giftSection || !inst.enableGift) return;
    var allUnlocked = unlockedIndex === inst.thresholds.length - 1;
    if (allUnlocked) {
      giftSection.classList.add("is-visible");
    } else {
      giftSection.classList.remove("is-visible");
    }
  }

  /* ===== GIFT STATE ===== */

  function findActiveGiftInCart(cart) {
    activeGiftKey = null;
    if (!cart || !cart.items) return;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.properties && item.properties[freeGiftLineProperty] === "true") {
        activeGiftKey = item.key;
        break;
      }
    }
    updateGiftButtonStates();
  }

  function updateGiftButtonStates() {
    document.querySelectorAll("[data-section-id][data-config]").forEach(function (section) {
      var cards = section.querySelectorAll(".et-discount-bar__product-card");
      cards.forEach(function (card) {
        var btn = card.querySelector(".et-discount-bar__add-gift-btn");
        if (!btn) return;
        var variantId = card.getAttribute("data-selected-variant");
        var isInCart = false;

        if (activeGiftKey && currentCart) {
          for (var i = 0; i < currentCart.items.length; i++) {
            var item = currentCart.items[i];
            if (item.key === activeGiftKey && String(item.variant_id) === String(variantId)) {
              isInCart = true;
              break;
            }
          }
        }

        if (isInCart) {
          btn.classList.add("et-discount-bar__add-gift-btn--remove");
          btn.setAttribute("data-action", "remove");
          btn.innerHTML =
            '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 256 256" fill="currentColor"><path d="M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm96,168H64V64H192ZM112,104v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Z"/></svg>';
        } else {
          btn.classList.remove("et-discount-bar__add-gift-btn--remove");
          btn.setAttribute("data-action", "add");
          btn.innerHTML =
            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.833496 3.9585C0.833496 3.61332 1.11332 3.3335 1.4585 3.3335H2.56346C3.1576 3.3335 3.69234 3.69394 3.91525 4.24467L4.22105 5.00016H16.8752C17.0809 5.00016 17.2734 5.10138 17.39 5.27082C17.5066 5.44026 17.5324 5.65624 17.4589 5.84837L15.1603 11.8603C14.821 12.7475 13.9696 13.3335 13.0197 13.3335H7.79024C6.8566 13.3335 6.01629 12.7671 5.66599 11.9016L2.75657 4.71366C2.72472 4.63499 2.64833 4.5835 2.56346 4.5835H1.4585C1.11332 4.5835 0.833496 4.30367 0.833496 3.9585ZM4.727 6.25016L6.82467 11.4327C6.9839 11.826 7.36586 12.0835 7.79024 12.0835H13.0197C13.4515 12.0835 13.8385 11.8171 13.9927 11.4138L15.9671 6.25016H4.727Z" fill="white"/><path d="M7.0835 14.1668C7.77385 14.1668 8.3335 14.7265 8.3335 15.4168C8.3335 16.1072 7.77385 16.6668 7.0835 16.6668C6.39314 16.6668 5.8335 16.1072 5.8335 15.4168C5.8335 14.7265 6.39314 14.1668 7.0835 14.1668Z" fill="white"/><path d="M15.0002 15.4168C15.0002 14.7265 14.4405 14.1668 13.7502 14.1668C13.0598 14.1668 12.5002 14.7265 12.5002 15.4168C12.5002 16.1072 13.0598 16.6668 13.7502 16.6668C14.4405 16.6668 15.0002 16.1072 15.0002 15.4168Z" fill="white"/></svg>';
        }
      });
    });
  }

  function getSectionsToBundle() {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sections } })
    );
    return sections;
  }

  function addGiftToCart(variantId) {
    var promise = activeGiftKey
      ? removeGiftFromCart(activeGiftKey, true)
      : Promise.resolve();

    promise
      .then(function () {
        var properties = {};
        properties[freeGiftLineProperty] = "true";
        var sections = getSectionsToBundle();

        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "same-origin",
          body: JSON.stringify({
            items: [{ id: parseInt(variantId), quantity: 1, properties: properties }],
            sections: sections,
          }),
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        refreshAll();
        document.documentElement.dispatchEvent(
          new CustomEvent("variant:add", { bubbles: true, detail: { cart: data } })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", { bubbles: true, detail: { baseEvent: "variant:add", cart: data } })
        );
      })
      .catch(function (err) { console.error("ET Discount Bar: add gift error", err); });
  }

  function removeGiftFromCart(key, silent) {
    var sections = getSectionsToBundle();
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: key, quantity: 0, sections: sections }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        activeGiftKey = null;
        if (!silent) {
          refreshAll();
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:change", { bubbles: true, detail: { baseEvent: "line-item:change", cart: data } })
          );
        }
      });
  }

  /* ===== GLOBAL BAR ONLY: Toggle, Position, Swiper, Selectors, Popups ===== */

  function initGlobalBar(section) {
    var root = section.classList.contains("et-discount-bar__inner") ? section.parentNode : section;
    var inner = section.classList.contains("et-discount-bar__inner") ? section : section.querySelector(".et-discount-bar__inner");
    var header = section.querySelector(".et-discount-bar__header");
    var swiperContainer = section.querySelector(".et-discount-bar__swiper");
    var overlay = root.querySelector(".et-discount-bar__overlay");
    var infoPopup = root.querySelector(".et-discount-bar__popup--info");
    var zoomPopup = root.querySelector(".et-discount-bar__popup--zoom");

    /* Toggle */
    if (header) {
      header.addEventListener("click", function () {
        inner.classList.toggle("is-open");
        if (overlay) {
          if (inner.classList.contains("is-open")) {
            overlay.classList.add("is-visible");
          } else {
            overlay.classList.remove("is-visible");
          }
        }
      });
    }

    if (overlay) {
      overlay.addEventListener("click", function () {
        var popupOpen = (infoPopup && infoPopup.classList.contains("is-visible")) ||
                        (zoomPopup && zoomPopup.classList.contains("is-visible"));
        if (popupOpen) {
          closeAllPopups();
        } else {
          inner.classList.remove("is-open");
          overlay.classList.remove("is-visible");
        }
      });
    }

    /* Position below header */
    function positionBelowHeader() {
      if (window.innerWidth <= 749) {
        section.style.top = "";
        return;
      }
      var headerSection = document.querySelector(".shopify-section--header, #shopify-section-header, .section-header");
      if (headerSection) {
        var rect = headerSection.getBoundingClientRect();
        section.style.top = Math.max(0, rect.bottom) + "px";
      }
    }
    positionBelowHeader();
    window.addEventListener("resize", positionBelowHeader);
    window.addEventListener("scroll", function () {
      requestAnimationFrame(positionBelowHeader);
    }, { passive: true });

    /* Swiper */
    function initSwiper() {
      if (!swiperContainer) return;
      if (typeof Swiper === "undefined") {
        setTimeout(initSwiper, 100);
        return;
      }
      new Swiper(swiperContainer, {
        slidesPerView: 1.15,
        centeredSlides: true,
        centeredSlidesBounds: true,
        spaceBetween: 8,
        pagination: {
          el: ".et-discount-bar__swiper-pagination",
          clickable: true,
          bulletClass: "et-discount-bar__swiper-bullet",
          bulletActiveClass: "et-discount-bar__swiper-bullet--active",
        },
        scrollbar: {
          el: ".et-discount-bar__swiper-scrollbar",
          draggable: true,
        },
        navigation: {
          nextEl: ".et-discount-bar__swiper-next",
          prevEl: ".et-discount-bar__swiper-prev",
        },
      });
    }
    initSwiper();

    /* Gift buttons */
    section.addEventListener("click", function (e) {
      var btn = e.target.closest(".et-discount-bar__add-gift-btn");
      if (!btn) return;
      e.preventDefault();
      var card = btn.closest(".et-discount-bar__product-card");
      if (!card) return;
      var action = btn.getAttribute("data-action");
      if (action === "remove" && activeGiftKey) {
        removeGiftFromCart(activeGiftKey);
      } else {
        var variantId = card.getAttribute("data-selected-variant");
        if (variantId) addGiftToCart(variantId);
      }
    });

    /* Variant selectors */
    section.addEventListener("click", function (e) {
      var trigger = e.target.closest(".et-discount-bar__selector-trigger");
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        var selector = trigger.closest(".et-discount-bar__selector") || trigger.parentElement;
        var isOpen = selector.classList.contains("is-open");
        closeAllDropdowns();
        if (!isOpen) {
          selector.classList.add("is-open");
          trigger.setAttribute("aria-expanded", "true");
          positionDropdown(selector);
        }
      }
    });

    document.addEventListener("click", function (e) {
      var option = e.target.closest(".et-discount-bar__selector-option");
      if (!option) {
        if (!e.target.closest(".et-discount-bar__selector-trigger")) {
          closeAllDropdowns();
        }
        return;
      }
      e.preventDefault();
      e.stopPropagation();

      var dropdown = option.closest(".et-discount-bar__selector-options");
      var sel = dropdown ? dropdown._sourceSelector : null;
      var card = dropdown ? dropdown._sourceCard : null;

      dropdown.querySelectorAll(".et-discount-bar__selector-option").forEach(function (o) {
        o.classList.remove("et-discount-bar__selector-option--active");
      });
      option.classList.add("et-discount-bar__selector-option--active");

      if (option.dataset.productId && card) {
        var trig = sel ? sel.querySelector(".et-discount-bar__selector-trigger") : null;
        var valueSpan = trig ? trig.querySelector("[data-selector-value]") : null;
        var colorCircle = trig ? trig.querySelector(".et-discount-bar__selector-color-circle") : null;

        if (valueSpan && option.dataset.colorLabel) valueSpan.textContent = option.dataset.colorLabel;
        if (valueSpan && option.dataset.sizeValue) valueSpan.textContent = option.dataset.sizeValue;
        if (colorCircle && option.dataset.colorValue) colorCircle.style.backgroundColor = option.dataset.colorValue;

        card.setAttribute("data-product-id", option.dataset.productId);
        card.setAttribute("data-selected-variant", option.dataset.variantId);
        if (option.dataset.productTitle) card.setAttribute("data-product-title", option.dataset.productTitle);
        if (option.dataset.productImages) card.setAttribute("data-product-images", option.dataset.productImages);
        if (option.dataset.productPrice) card.setAttribute("data-product-price", option.dataset.productPrice);
        if (option.dataset.productDescription) card.setAttribute("data-product-description", option.dataset.productDescription);

        var img = card.querySelector(".et-discount-bar__product-image");
        if (img && option.dataset.productImage) img.src = option.dataset.productImage;
        var titleEl = card.querySelector(".et-discount-bar__product-title");
        if (titleEl && option.dataset.productTitle) titleEl.textContent = option.dataset.productTitle;
        var priceEl = card.querySelector(".et-discount-bar__product-original-price");
        if (priceEl && option.dataset.productPrice) priceEl.textContent = option.dataset.productPrice;
      } else if (option.dataset.variantId && card) {
        card.setAttribute("data-selected-variant", option.dataset.variantId);
        var nameEl = sel ? sel.querySelector("[data-selector-value]") : null;
        if (nameEl) nameEl.textContent = option.dataset.variantTitle;
        var swatchEl = sel ? sel.querySelector(".et-discount-bar__selector-color-circle") : null;
        if (swatchEl && option.dataset.variantColor) swatchEl.style.backgroundColor = option.dataset.variantColor;
        if (option.dataset.variantImage) {
          var vImg = card.querySelector(".et-discount-bar__product-image");
          if (vImg) vImg.src = option.dataset.variantImage;
        }
      }
      closeAllDropdowns();
    });

    function positionDropdown(selector) {
      var trig = selector.querySelector(".et-discount-bar__selector-trigger");
      var dd = selector.querySelector(".et-discount-bar__selector-options");
      if (!trig || !dd) return;
      var card = selector.closest(".et-discount-bar__product-card");
      dd._originalParent = dd.parentElement;
      dd._sourceSelector = selector;
      dd._sourceCard = card;
      document.body.appendChild(dd);
      dd.style.display = "block";
      var rect = trig.getBoundingClientRect();
      dd.style.left = rect.left + "px";
      dd.style.width = rect.width + "px";
      dd.style.bottom = (window.innerHeight - rect.top + 4) + "px";
      dd.style.top = "auto";
    }

    function closeAllDropdowns() {
      document.querySelectorAll("body > .et-discount-bar__selector-options").forEach(function (dd) {
        dd.style.display = "";
        dd.style.left = "";
        dd.style.width = "";
        dd.style.bottom = "";
        dd.style.top = "";
        if (dd._originalParent) dd._originalParent.appendChild(dd);
        dd._originalParent = null;
        dd._sourceSelector = null;
        dd._sourceCard = null;
      });
      section.querySelectorAll(".et-discount-bar__selector.is-open, [style*='position:relative'].is-open").forEach(function (sel) {
        sel.classList.remove("is-open");
        var t = sel.querySelector(".et-discount-bar__selector-trigger");
        if (t) t.setAttribute("aria-expanded", "false");
      });
    }

    /* Popups */
    if (overlay) overlay.addEventListener("click", closeAllPopups);

    section.addEventListener("click", function (e) {
      var infoTrigger = e.target.closest(".et-discount-bar__free-pan-link");
      if (infoTrigger && infoPopup) {
        e.preventDefault();
        openPopup(infoPopup);
        return;
      }
      var zoomTrigger = e.target.closest(".et-discount-bar__zoom-btn");
      if (zoomTrigger && zoomPopup) {
        e.preventDefault();
        var card = zoomTrigger.closest(".et-discount-bar__product-card");
        if (card) populateZoomPopup(card);
        openPopup(zoomPopup);
        return;
      }
      var closeBtn = e.target.closest(".et-discount-bar__popup-close");
      if (closeBtn) { closeAllPopups(); return; }
      var thumbBtn = e.target.closest(".et-discount-bar__zoom-thumb");
      if (thumbBtn) {
        var imgSrc = thumbBtn.querySelector("img");
        if (imgSrc) {
          var mainImg = zoomPopup.querySelector(".et-discount-bar__zoom-main-img");
          if (mainImg) mainImg.src = imgSrc.src;
          zoomPopup.querySelectorAll(".et-discount-bar__zoom-thumb").forEach(function (t) { t.classList.remove("is-active"); });
          thumbBtn.classList.add("is-active");
        }
      }
    });
    root.addEventListener("click", function (e) {
      var closeBtn = e.target.closest(".et-discount-bar__popup-close");
      if (closeBtn) { closeAllPopups(); return; }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeAllPopups();
    });

    function openPopup(popup) {
      if (overlay) overlay.classList.add("is-visible");
      popup.classList.add("is-visible");
      inner.style.zIndex = "998";
      document.body.style.overflow = "hidden";
    }

    function closeAllPopups() {
      if (infoPopup) infoPopup.classList.remove("is-visible");
      if (zoomPopup) zoomPopup.classList.remove("is-visible");
      inner.style.zIndex = "";
      document.body.style.overflow = "";
    }

    function populateZoomPopup(card) {
      if (!zoomPopup) return;
      var title = card.getAttribute("data-product-title") || "";
      var imagesStr = card.getAttribute("data-product-images") || "";
      var images = imagesStr ? imagesStr.split("|||") : [];
      var description = card.getAttribute("data-product-description") || "";
      var price = card.getAttribute("data-product-price") || "";

      var titleEl = zoomPopup.querySelector(".et-discount-bar__zoom-title");
      if (titleEl) titleEl.textContent = title;
      var descEl = zoomPopup.querySelector(".et-discount-bar__zoom-desc");
      if (descEl) descEl.textContent = description;
      var comparePriceEl = zoomPopup.querySelector(".et-discount-bar__zoom-compare-price");
      if (comparePriceEl) comparePriceEl.textContent = price;

      var displayImages = images.slice(0, 5);
      var mainImg = zoomPopup.querySelector(".et-discount-bar__zoom-main-img");
      if (mainImg && displayImages.length > 0) mainImg.src = displayImages[0];

      var thumbsContainer = zoomPopup.querySelector(".et-discount-bar__zoom-thumbs");
      if (thumbsContainer) {
        thumbsContainer.innerHTML = "";
        displayImages.forEach(function (src, idx) {
          var btn = document.createElement("button");
          btn.className = "et-discount-bar__zoom-thumb" + (idx === 0 ? " is-active" : "");
          btn.type = "button";
          var img = document.createElement("img");
          img.src = src;
          img.alt = title;
          btn.appendChild(img);
          thumbsContainer.appendChild(btn);
        });
      }
    }
  }

  /* ===== INIT ===== */

  function init() {
    instances.forEach(function (inst) {
      if (!inst.isCart) initGlobalBar(inst.el);
    });
    interceptCartRequests();
    refreshAll();

    document.addEventListener("click", function (e) {
      var btn = e.target.closest(".et-discount-bar--cart .et-discount-bar__add-gift-btn");
      if (!btn) return;
      e.preventDefault();
      var card = btn.closest(".et-discount-bar__product-card");
      if (!card) return;
      var action = btn.getAttribute("data-action");
      if (action === "remove" && activeGiftKey) {
        removeGiftFromCart(activeGiftKey);
      } else {
        var variantId = card.getAttribute("data-selected-variant");
        if (variantId) addGiftToCart(variantId);
      }
    });

    document.addEventListener("change", function (e) {
      var select = e.target.closest(".et-discount-bar--cart .et-discount-bar__cart-select");
      if (!select) return;
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      var card = select.closest(".et-discount-bar__product-card");
      if (!card) return;
      var variantId = opt.value || opt.getAttribute("data-variant-id");
      if (variantId) card.setAttribute("data-selected-variant", variantId);
      var img = opt.getAttribute("data-product-image");
      if (img) {
        var imgEl = card.querySelector(".et-discount-bar__product-image");
        if (imgEl) imgEl.src = img;
      }
      var title = opt.getAttribute("data-product-title");
      if (title) {
        var titleEl = card.querySelector(".et-discount-bar__product-title");
        if (titleEl) titleEl.textContent = title;
      }
      var price = opt.getAttribute("data-product-price");
      if (price) {
        var priceEl = card.querySelector(".et-discount-bar__product-compare-price");
        if (priceEl) priceEl.textContent = price;
      }
    });

    document.addEventListener("cart:changed", function () {
      setTimeout(refreshAll, 300);
    });
    document.documentElement.addEventListener("cart:change", function () {
      setTimeout(refreshAll, 300);
    });


  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
